import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/LoginModal.module.scss';

import Button from './Button';

import Loading from './Loading';
import Dialog from './Dialog';

/**
 * An overlay modal to show that the user needs to modify their settings.
 * Will redirect the user after the initial state of countDownTime number
 * of seconds.
 *
 * @returns React.JSX.Element
 */
const Modal: React.FunctionComponent = () => {
  const [showModal, setShowModal] = useState<boolean>(true);
  const [countDownTime, setCountDownTime] = useState<number>(10);
  const { t } = useTranslation();

  const goToDetailsPage = (): void => {
    if (import.meta.env.VITE_IAM_MANDATE) {
      window.location.replace(import.meta.env.VITE_IAM_MANDATE);
    }
  };

  useEffect(() => {
    if (countDownTime > 0) {
      const interval = setInterval(() => {
        setCountDownTime(countDownTime - 1);
      }, 1000);
      return (): void => clearInterval(interval);
    } else {
      goToDetailsPage();
    }
  }, [countDownTime]);

  return (
    <Dialog openModal={showModal} closeModal={() => setShowModal(false)}>
      <div className={styles.modal}>
        <h2>{t('common:greetings.noUserData')}</h2>
        <p>{t('common:greetings.noUserDataRedirect')}</p>
        <p>{t('common:greetings.redirect')}</p>
        <Loading size="small" />
        <Button
          onClick={(e): void => {
            e.preventDefault();
            goToDetailsPage();
          }}
        >
          {t('common:general.makeAuthReq')}
        </Button>
      </div>
    </Dialog>
  );
};

export default Modal;
